import React, { useEffect, useState } from "react";
// import EPaperButton from "../../../atoms/e-paper-button";
// import HeaderNewsletter from "../../../atoms/header-newsletter";
import HeaderNotification from "../../../atoms/header-notification";
import "./header-right.m.css";
import AccountBtn from "../../../atoms/account-btn";
import SubscribeBtn from "../../../atoms/subscribe-btn";
import { useSelector } from "react-redux";
import { get } from "lodash";
import HamburgerAndSearch from "../../../atoms/hamburger-and-search";

function HeaderRight({ openNotificationModal, hideTheMenu = false, isSubscriber: propIsSubscriber }) {
  const reduxIsSubscriber = useSelector((state) => get(state, ["qt", "config", "subscriber"], "") === "true");
  const isSubscriber = propIsSubscriber || reduxIsSubscriber;

  return (
    <>
      <div styleName="row row1">
        {/* <HeaderNewsletter /> */}
        {/* <EPaperButton /> */}
        {/* <div className="hide-desktop-tab">
          <div onClick={openNotificationModal}>
            <HeaderNotification />
          </div>
        </div> */}
      </div>
      <div styleName="row row2">
        {!isSubscriber && <SubscribeBtn />}
        <AccountBtn />
        <HamburgerAndSearch hideTheMenu={hideTheMenu} />
      </div>
    </>
  );
}

export default HeaderRight;
